// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__NDtpu","signatureBlock":"Footer_signatureBlock__1vJiN","signature":"Footer_signature__9GkLn"};